<script>
import { Bar } from 'vue-chartjs'
export default {
    name: 'revenues',
    extends: Bar,
    props: [
        "options",
        "chartData"
    ],
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
}
</script>
<style scoped>

</style>